import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';
import {ShortVoter} from '../../models/ShortVoter';

@Component({
  selector: 'representative-popup',
  templateUrl: './representative-popup.component.html',
  styleUrls: ['./representative-popup.component.less', '../../shared/common.less']
})
export class RepresentativePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() mails: Array<ShortVoter>;
  @Input() representationData: any;
  @Input() isAssessors = false;
  @Input() assessors = []

  // Tableaux séparés pour les noms et emails
  names: string[] = [];
  emails: string[] = [];

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {
    
  }

}
